<template>
  <page>
    <v-card>
      <form>
        <message :messages="messages"></message>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex lg6 sm6 xs12>
                        <v-select
                          :items="riTypeIOList"
                          v-model="form.riType"
                          :label="label.riType"
                          item-text="label"
                          item-value="value"
                          data-vv-name="form.riType"
                          :data-vv-as="label.riType"
                          :error-messages="errors.collect('form.riType')">
                        </v-select>
                      </v-flex>
                      <v-flex lg6 sm6 xs12>
                        <v-text-field
                          v-model="form.genTtyRef"
                          :label="label.genTtyRef"
                          data-vv-name="form.genTtyRef"
                          :data-vv-as="label.genTtyRef"
                          append-icon="mdi-magnify"
                          @click:append="getHelpList('genTtyRef')"
                          :error-messages="errors.collect('form.genTtyRef')"
                          :disabled="this.form.riType === undefined">
                        </v-text-field>
                      </v-flex>
                      <!-- <v-flex lg6 sm6 xs12>
                        <v-autocomplete :items="riTypeList" v-model="form.riType" :label="label.riType" item-text="label" item-value="value" data-vv-name="form.riType" :data-vv-as="label.riType" :error-messages="errors.collect('form.riType')"></v-autocomplete>
                      </v-flex> -->
                      <v-flex xs6>
                        <cal-picker v-model="form.acctPeriodEndFrom" :label="label.acctPeriodEndFrom" :data-vv-as="label.acctPeriodEndFrom" data-vv-name="acctPeriodEndFrom" :error-messages="errors.collect('acctPeriodEndFrom')" v-validate="'required'"></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker v-model="form.acctPeriodEndTo" :label="label.acctPeriodEndTo" :data-vv-as="label.acctPeriodEndTo" data-vv-name="acctPeriodEndTo" :error-messages="errors.collect('acctPeriodEndTo')" v-validate="checkAcctPeriodEndTo"></cal-picker>
                      </v-flex>
                      <v-flex lg6 sm6 xs12>
                        <v-text-field
                          v-model="form.stmtTtyRef"
                          :label="label.stmtTtyRef"
                          v-validate="stmtTtyRefValidate"
                          data-vv-name="form.stmtTtyRef"
                          :data-vv-as="label.stmtTtyRef"
                          @blur="checkStmtTtyRef"
                          :error-messages="errors.collect('form.stmtTtyRef')"
                          :hint="'EX: JAN2021,FEB2021'">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <div class="header-padding body-1">Copy to new statement</div>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker v-model="form.newAcctPeriodEndDate" :label="label.newAcctPeriodEndDate" :data-vv-as="label.newAcctPeriodEndDate" data-vv-name="newAcctPeriodEndDate" :error-messages="errors.collect('newAcctPeriodEndDate')" v-validate="'required'"></cal-picker>
                      </v-flex>
                      <v-flex lg6 sm6 xs12>
                        <v-text-field
                          v-model="form.newStmtTtyRef"
                          :label="label.newStmtTtyRef"
                          v-validate="'required'"
                          data-vv-name="form.newStmtTtyRef"
                          :data-vv-as="label.newStmtTtyRef"
                          :error-messages="errors.collect('form.newStmtTtyRef')"
                          :hint="'EX: JAN2021,FEB2021'">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker v-model="form.newTranDate" :label="label.newTranDate" :data-vv-as="label.newTranDate" data-vv-name="newTranDate" :error-messages="errors.collect('newTranDate')" v-validate="newTranDateValidate" @change="checkNewTranDate"></cal-picker>
                      </v-flex>
                    </v-layout>
                     <v-layout row wrap>
                      <v-flex xs12 class="pt-3">
                        <v-btn color="primary" dark @click.prevent="doGenerate()">
                            {{label.generate}}<v-icon dark right >mdi-arrow-right-bold-box</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
      </form>
    </v-card>
    <v-dialog v-model="helpList" width="900px" persistent>
      <!-- Helplist component -->
      <treatyByTtyType-help-list
        :mode="mode"
        :param="param"
        :riType="riType"
        v-if="treatyByTtyTypeHelplist"
        @close="doClose"
        @doAssign="doAssign($event)">
      </treatyByTtyType-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { commonMixins } from '@/mixins/common/commonMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import TreatyByTtyTypeHelpListMultiSelect from '../helplist/TreatyByTtyTypeHelpListMultiSelect'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

export default {
  data() {
    return {
      selectedHelpList: undefined,
      helpList: false,
      treatyByTtyTypeHelplist: false,
      label: {
        riType: 'RI Type',
        genTtyRef: 'Generate for Treaty Ref',
        acctPeriodEndFrom: 'Account Period End Date From',
        acctPeriodEndTo: 'Account Period End Date To',
        stmtTtyRef: 'Statement Treaty Ref',
        newAcctPeriodEndDate: 'New Account Period End Date',
        newStmtTtyRef: 'New Statement Treaty Ref Code',
        newTranDate: 'New Transaction Date',
        generate: 'Generate'
      },
      form: {
        riType: 'O',
        genTtyRef: 'All',
        acctPeriodEndFrom: new Date(),
        acctPeriodEndTo: new Date(),
        stmtTtyRef: undefined,
        newAcctPeriodEndDate: undefined,
        newStmtTtyRef: undefined,
        newTranDate: new Date()
      },
      panel: [0],
      riTypeIOList: [
        {
          label: 'Inwards',
          value: 'I'
        },
        {
          label: 'Outwards',
          value: 'O'
        }
      ],
      genTtyRefList: [
        {
          label: 'All',
          value: 'All'
        }
      ],
      stmtTtyRefList: [],
      stmtTtyRefLength: 0,
      sameStmtTtyRef: false,
      duplicateStmtTtyRef: undefined,
      stmtTtyRefError: false,
      newStmtTtyRefList: [],
      newStmtTtyRefLength: 0,
      sameNewStmtTtyRef: false,
      duplicateNewStmtTtyRef: undefined,
      newTranDateFound: false,
      param: '',
      mode: '',
      riType: ''
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('genQuartStmtInit')])
    },
    getHelpList(fieldName) {
      this.helpList = true
      if (fieldName === 'genTtyRef') {
        this.selectedHelpList = 'genTtyRef'
        this.treatyByTtyTypeHelplist = true
        this.param = this.form.genTtyRef
        this.riType = this.form.riType
      }
    },
    doClose() {
      this.helpList = false
      setTimeout(() => {
        this.treatyByTtyTypeHelplist = false
      }, 500)
    },
    doAssign(Obj) {
      switch (this.selectedHelpList) {
        case 'genTtyRef':
          this.form.genTtyRef = Obj.finalSelectedItems.toString()
          this.genTtyRefList = Obj.finalSelectedItems
      }
    },
    checkStmtTtyRef() {
      this.stmtTtyRef = this.form.stmtTtyRef === undefined ? undefined : this.form.stmtTtyRef.split(',')
      this.duplicateStmtTtyRef = undefined
      this.stmtTtyRefLength = 0
      this.stmtTtyRefList = []
      this.stmtTtyRefError = false
      this.resetMessages()
      // var currStmtTtyRef
      if (this.stmtTtyRef !== undefined) {
        if (this.stmtTtyRef.length > 3) {
          this.stmtTtyRefLength = this.stmtTtyRef.length
        }
        this.checkStmtTtyRefValidation(this.stmtTtyRef).then((result) => {
          if (result) {
            this.$validator.validate('form.stmtTtyRef').then((result) => {
              if (result) {
                if (this.stmtTtyRefList.length > 0 && this.form.genTtyRef === 'All') {
                  this.checkTop1TtyMaster()
                  // for (const stmtTtyRef of this.stmtTtyRefList) {
                  //   console.log(stmtTtyRef)
                  //   console.log(this.genQuartStmt)
                  // }
                } else {
                  this.checkTop1TtyMasterTtyRef()
                  // for (const genTtyRef of this.genTtyRefList) {
                  //   console.log(genTtyRef)
                  // }
                }
              }
            })
          }
        })
      }
      // const checkBlank = this.stmtTtyRef.map(element => {
      //   const checkStmtTtyRef = element.trim().toLowerCase()
      //   console.log(checkStmtTtyRef)
      //   if (currStmtTtyRef === undefined) {
      //     currStmtTtyRef = checkStmtTtyRef
      //     this.stmtTtyRefList.push(currStmtTtyRef)
      //     console.log(currStmtTtyRef)
      //   } else if (currStmtTtyRef !== checkStmtTtyRef && !this.stmtTtyRefList.includes(checkStmtTtyRef)) {
      //     currStmtTtyRef = checkStmtTtyRef
      //     this.stmtTtyRefList.push(currStmtTtyRef)
      //     console.log(currStmtTtyRef)
      //     console.log('Different StmtTtyRef')
      //   } else {
      //     this.sameStmtTtyRef = true
      //     this.duplicateStmtTtyRef = element
      //     console.log(element + ' - Same StmtTtyRef')
      //     this.$validator.validate('stmtTtyRefValidate')
      //   }
      //   return element.trim()
      // })
      // .then((result) => {
      //   if (result) {
      //     this.$validator.validate('form.stmtTtyRef')
      //   }
      // })
      // console.log(this.stmtTtyRefList)
      // if (checkBlank.includes('FEB2021')) {
      //   console.log('Contain FEB2021')
      // }
      // console.log(checkBlank)
    },
    async checkStmtTtyRefValidation() {
      try {
        var currStmtTtyRef

        const checkBlank = this.stmtTtyRef.map(element => {
          const checkStmtTtyRef = element.trim().toLowerCase()
          if (currStmtTtyRef === undefined) {
            currStmtTtyRef = checkStmtTtyRef
            this.stmtTtyRefList.push(currStmtTtyRef)
            // console.log(currStmtTtyRef)
          } else if (currStmtTtyRef !== checkStmtTtyRef && !this.stmtTtyRefList.includes(checkStmtTtyRef)) {
            currStmtTtyRef = checkStmtTtyRef
            this.stmtTtyRefList.push(currStmtTtyRef)
            // console.log(currStmtTtyRef)
            // console.log('Different StmtTtyRef')
          } else {
            this.sameStmtTtyRef = true
            this.duplicateStmtTtyRef = element
            // console.log(element + ' - Same StmtTtyRef')
          }
          return element.trim()
        })

        return checkBlank
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.message(data)
        }
        return false
      }
    },
    checkNewStmtTtyRef() {
      this.newStmtTtyRef = this.form.newStmtTtyRef === undefined ? undefined : this.form.newStmtTtyRef.split(',')
      this.duplicateNewStmtTtyRef = undefined
      this.newStmtTtyRefLength = 0
      this.newStmtTtyRefList = []
      // var currStmtTtyRef
      if (this.newStmtTtyRef !== undefined) {
        if (this.newStmtTtyRef.length > 3) {
          this.newStmtTtyRefLength = this.newStmtTtyRef.length
        }
        this.checkStmtTtyRefValidation(this.newStmtTtyRef).then((result) => {
          if (result) {
            this.$validator.validate('form.newStmtTtyRef').then((result) => {
              if (result) {
                if (this.newStmtTtyRefList.length > 0 && this.form.genTtyRef === 'All') {
                  this.checkTop1TtyMaster()
                  // for (const newStmtTtyRef of this.newStmtTtyRefList) {
                  //   console.log(newStmtTtyRef)
                  //   console.log(this.genQuartStmt)
                  // }
                } else {
                  this.checkTop1TtyMasterTtyRef()
                  // for (const genTtyRef of this.genTtyRefList) {
                  //   console.log(genTtyRef)
                  // }
                }
              }
            })
          }
        })
      }
    },
    async checkTop1TtyMaster() {
      this.stmtTtyRefError = false
      const apiUrl = this.genQuartStmt.checkTop1TtyMaster
      if (apiUrl) {
        try {
          const params = {
            riType: this.form.riType,
            acctPeriodEndFrom: this.form.acctPeriodEndFrom,
            acctPeriodEndTo: this.form.acctPeriodEndTo,
            stmtTtyRef: this.form.stmtTtyRef
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          // const { data } = result
          if (result) {
            // console.log(data)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.stmtTtyRefError = true
            this.message(data)
          }
          return false
        }
      }
    },
    async checkTop1TtyMasterTtyRef() {
      const apiUrl = this.genQuartStmt.checkTop1TtyMasterTtyRef
      if (apiUrl) {
        try {
          const params = {
            riType: this.form.riType,
            acctPeriodEndDateFrom: this.form.acctPeriodEndFrom,
            acctPeriodEndTo: this.form.acctPeriodEndTo,
            stmtTtyRef: this.form.stmtTtyRef,
            genTtyRef: this.form.genTtyRef
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result
          if (data) {
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async checkNewTranDate() {
      this.newTranDate = false
      this.resetMessages()
      const apiUrl = this.genQuartStmt.checkNewTranDate
      if (apiUrl) {
        try {
          const params = {
            newTranDate: this.form.newTranDate
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          if (result) {
            this.newTranDateFound = true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.newTranDateFound = false
            this.message(data)
          }
          return false
        }
      }
    },
    doGenerate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doGenerateQuartStmt()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doGenerateQuartStmt() {
      const apiUrl = this.genQuartStmt.doGenerateQuartStmt
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, this.form))
          const { data } = result
          if (data) {
            this.notify(data)
            // this.$router.push({ name: 'genQrtlyStmt' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  created() {
    this.doInit()

    this.$store.dispatch('treatyManagementInit')

    this.$validator.extend('acctPeriodEndToValidation', {
      getMessage(field, args) {
        return `Must be greater ot equal to 'From' date`
      },
      validate(value, args) {
        var acctPeriodEndDateFrom = args[0]
        // var acctPeriodEndDateTo = args[1]
        if (isAfter(removeTime(acctPeriodEndDateFrom), removeTime(value))) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('stmtTtyRefValidation', {
      getMessage(field, args) {
        if (args[0] !== 'undefined') {
          return args[0] + ` is duplicate`
        } else if (args[1] > 3) {
          return `Statement Treaty Ref more than 3 value`
        } else if (args[2] === 'true') {
          return `Treaty Master not found`
        }
      },
      validate(value, args) {
        let duplicateStmtTtyRef = args[0]
        let stmtTtyRefLength = parseInt(args[1])
        let stmtTtyRefError = args[2]
        if (value) {
          if (duplicateStmtTtyRef !== 'undefined' || stmtTtyRefLength > 3 || stmtTtyRefError === 'true') {
            return false
          } else {
            return true
          }
        }
      }
    })

    this.$validator.extend('newTranDateValidation', {
      getMessage(field, args) {
        // if (args[0] !== 'undefined') {
        //   return args[0] + ` is duplicate`
        // } else if (args[1] > 3) {
        return `Account Period not found`
        // }
      },
      validate(value, args) {
        let acctPeriodFound = args[0]
        if (value) {
          if (acctPeriodFound === 'false') {
            return false
          } else {
            return true
          }
        }
      }
    })
  },
  computed: {
    menu() {
      return this.$store.state.treatyParam.menu
    },
    genQuartStmt() {
      return this.$store.state.specFuncTtyAcct.genQuartStmt.menu
    },
    checkAcctPeriodEndTo() {
      return 'required|acctPeriodEndToValidation:' + this.form.acctPeriodEndFrom + ',' + this.form.acctPeriodEndTo
    },
    stmtTtyRefValidate() {
      return 'required|stmtTtyRefValidation:' + this.duplicateStmtTtyRef + ',' + this.stmtTtyRefLength + ',' + this.stmtTtyRefError
    },
    newStmtTtyRefValidate() {
      return 'required|newStmtTtyRefValidation:' + this.duplicateStmtTtyRef + ',' + this.stmtTtyRefLength
    },
    newTranDateValidate() {
      return 'required|newTranDateValidation:' + this.newTranDateFound
    }
  },
  watch: {
  },
  mixins: [MessageMixin, commonMixins, commonAjaxMixin, helpListMixin
  ],
  components: {
    'treatyByTtyType-help-list': TreatyByTtyTypeHelpListMultiSelect
  }
}
</script>
